module.exports = __webpack_public_path__ + "img/metamask.731f32b9.svg";